import React from 'react'

const Services = () => {
  return(
    <>service</>
  )
}

export default Services